class PartReplacementJS {
    constructor() {
        const observer = new MutationObserver((mutations, observer) => {
            var targetElement = document.querySelector('[data-forms-id="forms-root-352029"] #app-embed');
            if (targetElement) {  
              
                // Disconnect the observer once the element is found
                observer.disconnect();
                this._applyCss(targetElement);
            }
        });  
        // Observe changes in the entire document
        observer.observe(document.body, { childList: true, subtree: true });
    }

    _applyCss(targetElement) {
        const shadowRoot = targetElement.shadowRoot;
        const style = document.createElement('style');
        style.textContent = `
            ._inline_stahb_47 ._formContainer_stahb_30 {
                max-width: 100% !important;
            }
            ._formContainer_stahb_30 ._textHeading_2aowh_35 {
                font-size: 22px !important;
                font-weight: 400 !important;
                line-height: 1.2 !important;
                text-align: start !important;
                margin-bottom: .5rem !important;
                letter-spacing: -0.03em !important;
                font-family: filson-soft !important;
            }
            form ._formFieldContainer_1ydxd_5 > label {
                top: 0 !important;
                left: 0 !important;
                order: 1 !important;
                color: #231F20 !important;
                font-size: 15px !important;
                transform: none !important;
                line-height: 1.5 !important;
                font-weight: 300 !important;
                position: relative !important;
                pointer-events: all !important;
                margin-bottom: .25rem !important;
                font-family: filson-soft !important;
            }
            form ._formFieldContainer_1ydxd_5 > input,
            form ._formPhoneInputContainer_1ym3p_6 ._selectToggle_1yit2_25,
            form ._selectContainer_1yit2_6 ._selectToggle_1yit2_25 {
                order: 2 !important;
                display: block !important;
                min-height: auto !important;
                padding: 11px 20px !important;
                font-family: filson-soft !important;
                font-size: 15px !important;
                font-weight: 300 !important;
                line-height: 20px !important;
                color: #231F20 !important;
                background-color: #ffffff !important;
                background-clip: padding-box !important;
                border: 1px solid #A7A5A6 !important;
                border-radius: 30px !important;
                letter-spacing: -.02em !important;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none !important;
                -webkit-transition: border-color .15s ease-in-out;
                transition: border-color .15s ease-in-out !important;
            }
            .info-badge:after {
                content: ""; background: url(https://cdn.shopify.com/s/files/1/0608/1865/3289/files/info.svg?v=1740551844) no-repeat center;
                background-size: 15px 15px;
                width: 15px;
                height: 15px;
                display: inline-block; 
                margin-left: 10px; 
                vertical-align: middle; 
                cursor: pointer;
            }
            form ._formPhoneInputContainer_1ym3p_6 {
                align-items: end;
            }
            ._formPhoneInputContainer_1ym3p_6 ._selectContainer_1yit2_6 ._selectToggle_1yit2_25,
            ._formPhoneInputContainer_1ym3p_6 ._selectContainer_1yit2_6 ._selectToggle_1yit2_25 ._selectToggleText_1yit2_25 {
                display: flex !important;
                align-items: center !important;
            }
            form [type="submit"] {
                width: fit-content !important;
                padding: 14px 29px !important;
                margin: 0 auto !important;
                display: inline-block !important;
                color: #fff !important;
                background-color: #231F20 !important;
                font-weight: 700 !important;
                border-radius: 30px !important;
                font-family: filson-soft !important;
                text-transform: lowercase !important;
                border: 1px solid #231F20 !important;
                transition: all .15s ease-in-out;
            }
            form [type="submit"]:hover {
                border-color: #4F4C4D !important;
                background-color: #4F4C4D !important;
            }
            @media (min-width: 768px) {
                ._formContainer_stahb_30 ._textHeading_2aowh_35 {
                    font-size: 24px !important;
                }
            }@media (min-width: 1025px) {
                ._formContainer_stahb_30 ._textHeading_2aowh_35 {
                    font-size: 30px !important;
                }
            }
        `;
        shadowRoot.querySelector("[data-form-root]").appendChild(style);
    
        const labels = [
            { id: "batch_code", text: "( only on some playhouses )" },
            { id: "plaque_id_number", text: "( All swing sets and some playhouses )" },
            { id: "model_name", text: "" },
            { id: "model_number", text: "" }
        ];
    
        labels.forEach(({ id, text }) => {
            const element = shadowRoot.querySelector(`[id="label-custom#${id}"]`);
            if (element) {
                const label = element.innerText;
                element.innerHTML = `${label} <span class="info-badge" data-modal-opener-part-replacement="${id}"></span> ${text}`;
            }
        });
    
        shadowRoot.querySelectorAll("[data-modal-opener-part-replacement]").forEach(ele => {
            ele.addEventListener("click", (event) => this._openInfoPopup(event));
        });
    
        console.log(shadowRoot.querySelector(`[id="label-custom#model_name"]`));
    }
    
    _openInfoPopup(event) {
        event.preventDefault();
        const modalType = event.currentTarget.getAttribute('data-modal-opener-part-replacement');
        document.querySelectorAll("[data-modal-type]").forEach(ele => ele.classList.add("d-none"));
        document.querySelector(`[data-modal-type="${modalType}"]`).classList.remove("d-none"); 
        const modal = document.querySelector("[data-part-modal]");
        if (modal) modal.classList.add("open"); 
        document.body.classList.add("scroll-fixed");
        siteOverlay.prototype.showOverlay();
    }
    


}


new PartReplacementJS();